import { setupApi, getCacheConfig } from '@http';

const ApiRootCache = getCacheConfig(5, 'api');

const handlerSuccess = function (res) {
  return res.data;
};

const handlerError = function (err) {
  const newError = err && err.response && err.response.data ? err.response.data : null;
  return Promise.reject(newError);
};

// ApiRoot
const ApiRoot = setupApi({
  baseURL: '/rest',
  cache: ApiRootCache
});

ApiRoot.interceptors.response.use(handlerSuccess, handlerError);

export default ApiRoot;
